export enum AppRoutes {

    // Auth...
    register = "/register",
    login = "/login",
    resetPassword = "/resetpassword",
    createNewPassword = "/createNewPassword",

    home = "/",
    profile = "/profile",

    // Sections...
    sections = "/brand-sections",
    section = "/brand-sections/:id",
    createStoreSection = "/brand-sections/create",
    sectionParams = "/brand-sections/",

    // Orders...
    orders = "/orders",
    order = "/orders/:id",
    createOrder = "/orders/create",
    orderParams = "/orders/",

    // Delivery Orders...
    deliveryOrders = "/delivery-orders",

    // New Orders...
    // newOrders = "/new-orders",
    // newOrder = "/new-orders/:id",
    // createNewOrder = "/new-orders/create",
    // newOrderParams = "/new-orders/",

    // Orders...
    deposits = "/deposits",
    deposit = "/deposits/:id",
    createDeposit = "/deposits/create",
    depositParams = "/deposits/",

    // Shipments...
    shipments = "/shipments",
    shipment = "/shipments/:id",
    createShipment = "/shipments/create",
    editShipment = "/shipments/edit/:id",
    shipmentsParams = "/shipments/",

    // Layout ...
    layout = "/layouts",
    layoutItem = "/layouts/:id",
    createLayoutItem = "/layouts/create",
    layoutItemParams = "/layouts/",
    
    // Scraping Items...
    scrapingItems = "/scraping-items",
    scrapingItem = "/scraping-items/:id",
    createScrapingItem = "/scraping-items/create",
    scrapingItemParams = "/scraping-items/",

    // Products...
    products = "/products",
    product = "/products/:id",
    createProduct = "/products/create",
    productParams = "/products/",

    // Outfits...
    outfits = "/outfits",
    outfit = "/outfits/:id",
    createOutfit = "/outfits/create",
    outfitParams = "/outfits/",

    // Categories...
    categories = "/sections",
    category = "/sections/:id",
    createCategory = "/sections/create",
    createSubcategory = "/sections/subcategory/create",
    categoryParams = "/sections/",
    subcategory = "/sections/:categoryId/subcategories/:id",

    // Groups...
    groups = "/groups",
    group = "/groups/:id",
    createGroup = "/groups/create",
    groupParams = "/groups/",

    // Customers...
    customers = "/customers",
    customer = "/customers/:id",
    createCustomer = "/customers/create",
    customerParams = "/customers/",
    customerCart = "/customers/:id/customer-cart",

    // Supports...
    supports = "/supports",
    support = "/supports/:id",
    supportParams = "/supports/",

    // Transactions...
    transactions = "/transactions",
    transaction = "/transactions/:id",
    transactionParams = "/transactions/",

    // Driver Transactions 
    driverTransactions = "/driver-transactions",
    driverTransaction = "/driver-transactions/:id",
    driverTransactionParams = "/driver-transactions/",

    // Reports...
    reports = "/reports",
    report = "/reports/:id",
    reportParams = "/reports/",
    

    // Advertisements...
    advertisements = "/advertisements",
    createAd = "/advertisements/create",
    advertisement = "/advertisements/:id",
    advertisementParams = "/advertisements/",

    // Offers...
    offers = "/offers",
    discounts = "/offers/discounts",
    discount = "/offers/discounts/:id",
    createDiscount = "/offers/discounts/create",
    discountParams = "/offers/discounts/",

    paymentMethodDiscounts = "/offers/payment-method-discounts",
    paymentMethodDiscount = "/offers/payment-method-discount/:id",
    createPaymentMethodDiscount = "/offers/payment-method-discount/create",
    paymentMethodDiscountParams = "/offers/payment-method-discount/",

    promoCodes = "/offers/promo-codes",
    promoCode = "/offers/promo-codes/:id",
    createPromoCode = "/offers/promo-codes/create",
    promoCodeParams = "/offers/promo-codes/",

    cartOffers = "/offers/cart-offers",
    cartOffer = "/offers/cart-offers/:id",
    createCartOffer = "/offers/cart-offers/create",
    cartOfferParams = "/offers/cart-offers/",

    // Cart Gifts...
    cartGifts = "/cart-gifts",
    cartGift = "/cart-gifts/:id",
    createCartGift = "/cart-gifts/create",
    cartGiftParams = "/cart-gifts/",

    // Notifications...
    notifications = "/notifications",
    createNotification = "/notifications/create",
    notification = "/notifications/:id",
    notificationParams = "/notifications/",

    // Settings...
    settings = "/settings",
    socialLinks = "/settings/sociallinks",
    security = "/settings/security",
    // Payment Methods...
        paymentMethods = "/settings/paymentMethods",
        createPaymentMethod = "/settings/paymentMethods/create",
        paymentMethod = "/settings/paymentMethods/:id",
        paymentMethodParams = "/settings/paymentMethods/",
    // Authirizations...
        authorizations = "/settings/authorizations",
        createAuthorization = "/settings/authorizations/create",
        authorization = "/settings/authorizations/:id",
        authorizationParams = "/settings/authorizations/",
    // Drivers...
        drivers = "/settings/drivers",
        createDriver = "/settings/drivers/create",
        driver = "/settings/drivers/:id",
        driverParams = "/settings/drivers/",
    // Teams...
        teams = "/settings/teams",
        createTeam = "/settings/teams/create",
        team = "/settings/teams/:id",
        teamParams = "/settings/teams/",
    // Provinces...
        provinces = "/settings/provinces",
        createProvince = "/settings/provinces/create",
        province = "/settings/provinces/:id",
        provinceParams = "/settings/provinces/",
        // Cities based on Provinces...
            cities = "/settings/provinces/:provinceId/cities",
    // Area Assigns
        areaAssigns = "/settings/area-assigns",
        areaAssignsCreate = '/settings/area-assigns/create',
        areaAssignsDetials = '/settings/area-assigns/:id',
        
    // Try On
        tryOn = "/settings/tryon",

    // Refunds...
    refunds = "/refunds",
    createRefund = "/refunds/create",
    editRefund = "/refunds/:id",
    
    // Refund Requests...
    refundRequests = "/refund-requests",
    editRefundRequest = "/refund-requests/:id",
    refundRequestDetails = "/refund-requests/details/:id",
    
    // Warehouses...
    warehouses = "/warehouses",
    createWarehouse = "/warehouses/create",
    editWarehouse = "/warehouses/:id",
    warehouseDetails = "/warehouses/details/:id",
    warehouseParams = "/warehouses/",

    // Watcher...
    watcher = "/watcher",
    watcherMessages = "/watcher/messages",
    watcherAutomation = "/watcher/automation",

    // respond.io...
    respondIO = "/respondio",

    // Helpdesk
    helpdesk = "/helpdesk",
    
    // TimeSheets
    timeSheet = "/timesheet",

    // Employees
    employees = "/employees",

    // Attendance
    attendance = "/attendance",

    // Recruitement
    recruitement = "/recruitement",

    // Time Off
    timeOff = "/timeoff",

    // ERP
    ERP = "/erp",
}

